import React from "react";
import SettingsSection from "../SettingsSection";
import EmbedImageField from "./EmbedImageField";
import ChannelPicker from "../ChannelPicker";

export default function LeaveSection({
  channels,
  selectedLeaveChannel,
  setSelectedLeaveChannel,
  leaveColor,
  setLeaveColor,
  leaveTitle,
  setLeaveTitle,
  leaveMsg,
  setLeaveMsg,
  leaveFooter,
  setLeaveFooter,
  showLeaveThumbnail,
  setShowLeaveThumbnail,
  showLeaveTimestamp,
  setShowLeaveTimestamp,
  leaveImage,
  setLeaveImage,
  logLeaves,
  setLogLeaves,
  guildId,
  apiBase,
  imageUploading,
  setImageUploading,
  isOpen,
  setIsOpen,
}) {
  return (
    <SettingsSection>
      <label className="input-label">LEAVE CHANNEL</label>
      <ChannelPicker
        channels={channels}
        value={selectedLeaveChannel}
        onChange={setSelectedLeaveChannel}
      />

      <label className="input-label">EMBED COLOR</label>
      <input
        type="color"
        value={leaveColor}
        onChange={(e) => setLeaveColor(e.target.value)}
        className="settings-input"
      />

      <label className="input-label">LEAVE TITLE</label>
      <input
        className="settings-input"
        value={leaveTitle}
        onChange={(e) => setLeaveTitle(e.target.value)}
        placeholder="✦ Farewell"
      />

      <label className="input-label">LEAVE MESSAGE</label>
      <textarea
        value={leaveMsg}
        onChange={(e) => setLeaveMsg(e.target.value)}
        className="settings-input large-text"
        placeholder="{user} has slipped back into the dark."
        style={{ minHeight: "100px" }}
      />

      <label className="input-label">FOOTER TEXT</label>
      <input
        className="settings-input"
        value={leaveFooter}
        onChange={(e) => setLeaveFooter(e.target.value)}
        placeholder="Nocturne bids you farewell."
      />

      <EmbedImageField
        label="EMBED IMAGE"
        helpText="Large image at the bottom of the leave embed. Upload a file or paste a public HTTPS URL."
        imageUrl={leaveImage}
        onUrlChange={setLeaveImage}
        onUploaded={setLeaveImage}
        onCleared={() => setLeaveImage("")}
        uploading={imageUploading}
        setUploading={setImageUploading}
        guildId={guildId}
        kind="leave"
        apiBase={apiBase}
      />

      <div className="toggle-group">
        <label>
          <input
            type="checkbox"
            checked={showLeaveThumbnail}
            onChange={(e) => setShowLeaveThumbnail(e.target.checked)}
          />{" "}
          Show User Thumbnail
        </label>
        <label>
          <input
            type="checkbox"
            checked={showLeaveTimestamp}
            onChange={(e) => setShowLeaveTimestamp(e.target.checked)}
          />{" "}
          Show Timestamp
        </label>
        <label>
          <input
            type="checkbox"
            checked={logLeaves}
            onChange={(e) => setLogLeaves(e.target.checked)}
          />{" "}
          Enable Leave Logging
        </label>
      </div>
      <p
        className="help-text"
        style={{ fontSize: "0.75rem", marginTop: "8px", opacity: 0.6 }}
      >
        Leave messages only send when logging is enabled. Also configurable via{" "}
        <code>/settings</code>.
      </p>
    </SettingsSection>
  );
}
